import React from "react";
import { Link } from "react-router-dom";
import "../style/Footer.css";
const Footer = () => {
  return (
    <footer id="footer">
      <div className="footer-content">
        <div className="footer-column">
          <div className="footer-title">
            <Link to="/">Other Resources</Link>
          </div>
          <ul className="footer-link-list">
            <li>
              <a rel="noopener noreferrer" target="_blank" href="/recordings">
                Recordings
              </a>
            </li>
            <li>
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://www.lulu.com/shop/search.ep?keyWords=heath+morber&type="
              >
                English Motet books
              </a>
            </li>
          </ul>
        </div>

        <div className="footer-column">
          <div className="footer-title">
            <Link to="/">About Heath</Link>
          </div>
          <ul className="footer-link-list">
            <li>
              <Link to="/about">About englishmotets.com</Link>
            </li>
            <li>
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://www.sjcnc.org/staff-members/heath-morber/"
              >
                St. Johns Catholic <br /> Newman Center
              </a>
            </li>
          </ul>
        </div>
        {/* <div className="footer-column">
          <div className="footer-title">
            <Link to="/">Contact</Link>
          </div>
          <ul className="footer-link-list">
            <li>
              <Link to="/">Lorem ipsum dolor sit</Link>
            </li>
            <li>
              <Link to="/">Lorem ipsum dolor sit</Link>
            </li>
            <li>
              <Link to="/">Lorem ipsum dolor sit</Link>
            </li>
          </ul>
        </div> */}
      </div>
      <div className="copyright">
        <p>Copyright {new Date().getFullYear()}</p>
      </div>
    </footer>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js